import { Matcher } from '../../models/searchservice/common/Matcher';
export function createFieldValueFilter(filter) {
    var fieldId = Object.keys(filter)[0];
    var matcher = Object.keys(filter[fieldId])[0];
    var value;
    if (matcher === Matcher.Between) {
        value = createNumberRangeValue(filter[fieldId][matcher]);
    }
    else {
        value = filter[fieldId][matcher];
    }
    return {
        fieldId: fieldId,
        matcher: matcher,
        value: value
    };
}
function createNumberRangeValue(value) {
    var numberRangeValue = {};
    Object.keys(value).forEach(function (limitMatcher) {
        if (limitMatcher === Matcher.GreaterThan || limitMatcher === Matcher.GreaterThanOrEqualTo) {
            numberRangeValue.start = { matcher: limitMatcher, value: value[limitMatcher] };
        }
        else if (limitMatcher === Matcher.LessThan || limitMatcher === Matcher.LessThanOrEqualTo) {
            numberRangeValue.end = { matcher: limitMatcher, value: value[limitMatcher] };
        }
    });
    return numberRangeValue;
}
//# sourceMappingURL=createFieldValueFilter.js.map